import { IconProps } from "../../utils/global-types/global-types";

const UserRoleIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9 9.292a3.208 3.208 0 1 0 0-6.417 3.208 3.208 0 0 0 0 6.417"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.792 9.879h.292a.73.73 0 0 1 .729.729v.875a.438.438 0 0 0 .875 0v-.875a1.605 1.605 0 0 0-1.667-1.604h-.229a1.605 1.605 0 0 0-1.604 1.604v.875a.438.438 0 0 0 .875 0v-.875a.73.73 0 0 1 .729-.73M10.198 14.84a1.6 1.6 0 0 1-.177-.732v-2.042a1.6 1.6 0 0 1 .583-1.237v-.221c0-.234.038-.465.11-.683A11 11 0 0 0 9 9.795c-1.938 0-3.653.484-4.718 1.21-.813.555-1.26 1.259-1.26 1.998v.846a.993.993 0 0 0 .99.991z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.271 14.108v-2.042c0-.564-.457-1.02-1.02-1.02h-2.626c-.563 0-1.02.457-1.02 1.02v2.042c0 .564.457 1.02 1.02 1.02h2.625a1.02 1.02 0 0 0 1.021-1.02m-2.77-1.313v.584a.438.438 0 0 0 .874 0v-.584a.438.438 0 0 0-.875 0"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default UserRoleIcon;
